import { c as _c } from "react/compiler-runtime";
export const IconTooltipArrow = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="currentColor"><path d="M4.28763 6.60627L0 0H14L9.71237 6.60627C8.51267 8.46458 5.49776 8.46458 4.28763 6.60627Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};